// Shared client-side password helpers.  Mirrors the server's
// `checkPasswordStrength` so the user sees the same verdict before they
// even click submit.  Server stays the source of truth — these are just for
// UX feedback.

export function passwordIssue(pw) {
  if (typeof pw !== "string" || pw.length < 6) {
    return "Password must be at least 6 characters";
  }
  let classes = 0;
  if (/[a-z]/.test(pw)) classes++;
  if (/[A-Z]/.test(pw)) classes++;
  if (/[0-9]/.test(pw)) classes++;
  if (/[^A-Za-z0-9]/.test(pw)) classes++;
  if (classes < 2) {
    return "Mix at least two of: lowercase, uppercase, numbers, symbols";
  }
  return null;
}

// 0–4 score for a strength meter.  Cheap and good enough for a visual cue.
export function passwordScore(pw) {
  if (!pw) return 0;
  let score = 0;
  if (pw.length >= 6)  score++;
  if (pw.length >= 10) score++;
  let classes = 0;
  if (/[a-z]/.test(pw)) classes++;
  if (/[A-Z]/.test(pw)) classes++;
  if (/[0-9]/.test(pw)) classes++;
  if (/[^A-Za-z0-9]/.test(pw)) classes++;
  if (classes >= 2) score++;
  if (classes >= 3) score++;
  return Math.min(score, 4);
}

export const STRENGTH_LABELS = ["Too short", "Weak", "Fair", "Good", "Strong"];
